<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 6L2.30959 8.7715C3.22229 9.86674 4.57432 10.5 6 10.5C7.42568 10.5 8.77771 9.86674 9.69042 8.7715L12 6L9.69042 3.2285C8.77771 2.13326 7.42568 1.5 6 1.5C4.57432 1.5 3.22229 2.13325 2.30959 3.2285L0 6ZM6 3.75C7.24264 3.75 8.25 4.75736 8.25 6C8.25 7.24264 7.24264 8.25 6 8.25C4.75736 8.25 3.75 7.24264 3.75 6C3.75 4.75736 4.75736 3.75 6 3.75Z"
            fill="currentColor"
        />
    </svg>
</template>
